export const panel = {
	closeEvent: {
		message:
			"Tem certeza de que quer fechar o evento? Isso fará checkout de todos os usuários e fechará o relatório, o estoque e os caixas.",
		finishedActivityDevices:
			"Existem {{finishedActivityDevices}} PDV's com operação em aberto!",
		eventNameMessage: "Digite o nome do evento para confirmar o fechamento",
		emptyName: "O nome do evento está vazio",
		incorectName: "O nome do evento está incorreto",
	},
	deleteEvent: {
		confirm: "Tem certeza de que quer remover o evento? Isso será uma ação permamente",
	},
	eventNotOpen: "Esse evento ainda não foi aberto",
	openEvent: "Abrir evento",
	eventStatus: "Status do evento",
	open: "Aberto",
	finished: "Fechado",
	canceled: "Cancelado",
	notOpened: "Não aberto",
	openedBy: "Aberto por",
	deletedEmployee: "removido",
	finishedActivityText: "{{activeDevices}} PDVs com operação em aberto",
	closeEventButton: "Fechar evento",
	removeEventButton: "Remover evento",
	goTo: "ir para",
	importConsumption: {
		title: "Importar Consumação",
		consumptionType: "Tipo de consumação",
		normal: "Normal",
		consumption: "Consumação",
		confirm: "Confirmar",
		consumptionErrors: "Consumações que falharam",
		document: "CPF",
		reason: "Motivo",
		import: "Importar consumação",
		balanceType: "Tipo de saldo",
		columns: {
			reason: "Razão",
			value: "Valor",
			document: "CPF",
			name: "Nome",
			email: "E-mail",
			phone: "Telefone",
			isForeign: "É estrangeiro?",
			gender: "Gênero",
		},
		successNotification: "Consumação importada!",
		warningNotification: "Os dados não foram enviados. Algumas consumações falharam",
		recharge: "Recarga",
		minimumConsumption: "Consumação antecipada",
		bonus: "Bônus",
		spreadsheet: "Planilha",
		user: "Usuário",
	},
	importConsumptionCardsGroup: {
		title: "Grupo de cartões",
		fields: {
			group: {
				label: "Nome do grupo de cartões",
				required: "Selecione um grupo de cartão",
			},
			balanceType: {
				label: "Tipo de Saldo",
				required: "O valor do saldo deve ser maior que zero",
			},
			balance: { label: "Valor do Saldo" },
		},
	},
	importConsumptionZigCode: {
		title: "Zig Code",
		fileName: "Planilha de Consumação",
		rechargeSuccess: "Recarga efetuada com sucesso!",
		balanceType: "Tipo de Saldo",
		columns: {
			reason: "Razão",
			value: "Valor",
			zigCode: "Zig Code",
		},
	},
	importConsumptionUser: {
		reason: "Motivo",
		document: "Documento",
		paymentMethod: "Método de pagamento",
		value: "Valor da recarga",
		submitRecharge: "Recarregar ",
		documentError: "Documento é obrigatório",
		paymentMethodError: "Método de pagamento é obrigatório",
		valueError: "Valor da recarga é obrigatório",
		recharge: "Recarga",
		minimumConsumption: "Consumação antecipada",
		bonus: "Bônus",
		documentType: "Tipo de documento",
		saveToDigitalCardQuestion:
			"Deseja salvar a recarga no cartão digital do cliente, se ele tiver um?",
		saveToDigitalCardQuestionPlural:
			"Deseja salvar as recargas nos cartões digitais dos clientes, se eles tiverem?",
	},
	publicCard: {
		title: "Público",
		totalPublic: "{{totalPublic}} estiveram no evento",
		allInsideText: "ainda estão curtindo",
		allOutsideText: "já foram embora",
		newPublicText: "novos clientes",
		oldPublicText: "retornaram",
		capacity: "Capacidade",
		people: "pessoas",
		genderCard: {
			invoice: "Faturado",
			averageTicket: "Ticket Médio",
			zeroTicket: "Ticket Zero",
			realTicket: "Ticket Real",
			male: "Homens",
			female: "Mulheres",
			other: "Não Binário",
		},
	},
	totalReceiptCard: {
		title: "Financeiro",
		notIdealStateMessage:
			"Essa informação só está disponivel em eventos a partir de 01/08/2017",
		averageTicket: "Ticket Médio",
		zeroTicket: "Ticket Zero",
		realTicket: "Ticket Real",
		receipt: "Receita",
		operationTable: {
			title: "Operação",
			operationMode: "Modo de operação",
			zigTable: "Zig Mesa",
			zigCard: "Zig Card",
			zigDelivery: "Zig Delivery",
			total: "Total",
			invoicing: "Faturamento",
		},
		column: {
			title: "Modo De Pagamento",
			bar: "Bar",
			value: "Valor",
			entrance: "Entrada",
			opened: "Contas em aberto",
			total: "Total",
			tableRow: {
				app: "Aplicativo",
				rappi: "Rappi Pay",
				ame: "Ame",
				uber: "Uber",
				ifood: "Ifood",
				deliveryOnline: "Delivery Online",
				delivery: "Delivery",
				cash: "Dinheiro",
				credit: "Crédito",
				debit: "Débito",
				voucher: "Voucher",
				anticipated: "Antecipado",
				postEvent: "Pago após evento",
				pix: "Pix",
				integratedFoodVoucher: "Vale-refeição",
				mbway: "Mbway",
				online: "Online",
			},
			entranceConsumptions: "Consumação bilheteria",
			extraConsumptions: "Consumação extra",
			adjustedReceipt: "Receita ajustada",
			rechargeReturned: "Recargas devolvidas",
			invoicing: "Faturamento",
			refundedPostPayments: "Estorno de pagamento",
		},
		errorContent: "Erro!",
		emptyContent: "Não há nada a mostrar aqui",
		timelineCard: {
			consumption: "Consumo",
			period: "Período",
			recharge: "Recargas",
			zigCardConsumption: "Consumo no Zig Card",
			tableConsumption: "Consumo no Zig Mesa",
			tooltipMessage: "{{titleMap}} no período de {{start}} a {{end}}",
			value: "Valor consumido",
		},
	},
	topClientsCard: {
		title: "Clientes que mais consomem",
		clientInfo: "Informações do cliente",
		clients: "Clientes",
		count: "Consumo",
	},
	vendorsResumeCard: {
		title: "Vendas por vendors",
		name: "Vendors",
		totalSold: "Total vendido",
	},
	topProductsPriceCard: {
		title: "Produtos por representação em vendas",
		allProductsSold: "Todos os produtos vendidos",
		altNavlink: "Link de navegação para relatório de todos os produtos vendidos",
		noData: "Sem Dados",
		other: "Outros",
		products: "Produtos",
		quantity: "Quantidade",
		consumption: "Consumo",
		unavailable: "Indisponivel",
	},
	totalOpenedTable: "mesa em aberto",
	totalOpenedTables: "mesas em aberto",
	totalTables: "Total de mesas",
	editEvent: {
		title: "Editar evento",
		confirm: "Confirmar",
		passTemplate: "ID do modelo do passe",
	},
	zigMesaOperationMode: {
		message: "Status do servidor no PDV",
		online: "Online",
		local: "Local",
	},
	operationCard: {
		title: "Operação Zig Mesa",
		peopleSingle: "Pessoa",
		peoplePlural: "Pessoas",
		tableSingle: "Mesa",
		tablePlural: "Mesas",
		time: "Horário",
	},
};
